import React from 'react';
import { useNavigate } from "react-router-dom";

const CaseStudies = ({caseStudiesCards}) => {
    const navigate = useNavigate();
  return (
    <div className="w-full py-16 lg:py-10 border-[#5b6882] border-t">
    <div className="w-[88%] lg:w-[80%] mx-auto">
      {/* Header Section */}
      <div className="mb-12 lg:mb-14">
        <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-white RoobertLight leading-[120%] mb-4">
          Case Studies
        </h2>
      </div> 

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-16 mb-12 lg:mb-16">
        {caseStudiesCards.map((card, index) => (
          <div
            key={index}
            className="bg-white lg:p-0 flex flex-col  min-h-[200px] lg:min-h-[360px] relative"
            onClick={() => navigate(`/caseStudies/${card.slug}`)}
          >
            <div class="h-[190px] w-full bg-gray-400">
              <img
                src={card.image}
                alt="case study"
                class="h-full w-full object-cover"
              />
            </div>
            <div class="p-4">
              <h3 class="font-bold text-sm text-blue-900">
                {card.text}
              </h3>
              <p class="text-xs text-blue-900 mt-2">
                {card.description}
              </p>
            </div>
            <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-1/2 h-1/3"></div>
          </div>
        ))}
      </div>
    </div>
  </div>
  )
}
 
export default CaseStudies;